
import { mapGetters } from 'vuex'
export default {
  inject: ['wordingPageProduct'],
  props: {
    productSelected: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      vxCareInstructions: 'common/getProductsCareInstructions',
    }),
    careInstructions() {
      if (
        this.productSelected.materials.care_instructions &&
        this.productSelected.materials.care_instructions.length > 0
      )
        return this.wordingPageProduct.material_care_care_instructions_list.filter(
          (instruction) =>
            this.productSelected.materials.care_instructions.includes(
              instruction.key
            )
        )
      else return []
    },
  },
  methods: {
    parseFillPower(fill_power) {
      return Math.round(fill_power * 100) / 100
    },
  },
}
